import { render } from "./TalkRoomDate.vue?vue&type=template&id=95d9f87a&ts=true"
import script from "./TalkRoomDate.vue?vue&type=script&lang=ts&setup=true"
export * from "./TalkRoomDate.vue?vue&type=script&lang=ts&setup=true"

import "./TalkRoomDate.vue?vue&type=style&index=0&id=95d9f87a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/communityTalk/talkRoom/TalkRoomDate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "95d9f87a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('95d9f87a', __exports__)) {
    api.reload('95d9f87a', __exports__)
  }
  
  module.hot.accept("./TalkRoomDate.vue?vue&type=template&id=95d9f87a&ts=true", () => {
    api.rerender('95d9f87a', render)
  })

}


export default __exports__